import {Component, computed, effect, inject, model, OnInit, signal, ViewChild} from '@angular/core';
import {FormsModule, NgForm} from "@angular/forms";
import {GtNgDatepickerModule} from "../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {notImplementedYet} from "../../../../app.constants";
import {RegisterMethod, RegistrantType, RightSearchResult, Source} from "../../../../../generated-model/model";
import {RightSearchResource} from "../../../../service/RightSearchResource";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {RightDetailComponent} from "../right-detail/right-detail.component";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {RegisterPanelComponent} from "../register-panel/register-panel.component";
import {MenuStageService} from "../../../../shared/commons/services/menu-stage.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {StringUtils} from "../../../../shared/commons/gt-ng-datepicker/utils/string-utils";
import {AlertDialogService} from "../../../../shared/commons/dialog/alert-dialog/alert-dialog.service";
import {BtnLk2Component} from "../../../../shared/components/btn-lk2/btn-lk2.component";
import {RegisterProxyComponent} from "../../register/proxy/register-proxy.component";
import {HasAnyAuthorityDirective} from "../../../../security/has-any-authority.directive";
import {RegistrationUtils} from "../../../../shared/commons/utils/registration-utils";

@Component({
  selector: 'app-right-search-by-thaid',
  standalone: true,
  imports: [
    FormsModule,
    GtNgDatepickerModule,
    NotFoundComponent,
    RightDetailComponent,
    SharedCommonModule,
    RegisterPanelComponent,
    BtnLk2Component,
    RegisterProxyComponent,
    HasAnyAuthorityDirective
  ],
  templateUrl: './right-search-by-thaid.component.html',
  styleUrl: './right-search-by-thaid.component.scss'
})
export class RightSearchByThaidComponent implements OnInit {

  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  rightSearchResource = inject(RightSearchResource);
  menuStageService = inject(MenuStageService)
  data = signal(undefined as RightSearchResult);
  personalId = signal<string>(undefined);
  checkDate = model<string>(undefined);
  checkTime = model<string>(undefined);
  fromMenu = computed(() => this.menuStageService.getStoredMenu());
  protected readonly notImplementedYet = notImplementedYet;
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  maxDate = signal<NgbDateStruct>(undefined);
  alertDialogService = inject(AlertDialogService);
  source = model<Source>('NHSO');
  canBeRegistered = signal<boolean>(false);
  activeId = signal<number>(1);
  registrantType: RegistrantType = undefined;
  registerMethod: RegisterMethod = 'THAID';

  constructor() {
    effect(() => {
      this.canBeRegistered.set(
        this.activeId() == 1
        && this.data()
        && !this.data()?.personalFundBackDateList?.length
        && RegistrationUtils.showRegisterPanel(this.data()?.personalData, this.data()?.personalFundList?.[0])
      );
    }, {allowSignalWrites: true});
    let pid = this.router.getCurrentNavigation()?.extras?.state['pid'];
    if (!pid) {
      this.alertDialogService.open({content: 'กรุณาทำรายการใหม่อีกครั้ง'})
      this.router.navigate(['/secure/right-search']);
    }
    let date = new Date();
    this.maxDate.set({year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()});
    // this.personalId.set('3100500332928');
    this.personalId.set(pid);
  }

  ngOnInit(): void {
    this.initialValue();
    this.rightSearch();
  }

  private initialValue() {
    this.source.set('NHSO');
    this.resetCheckDateTime();
  }

  resetSearchParams() {
    this.resetCheckDateTime()
    this.source.set('NHSO');
    this.rightSearch();
  }

  resetCheckDateTime() {
    let now = new Date();
    this.checkDate.set(`${now.getFullYear()}-${StringUtils.paddingZeroLeft(now.getMonth() + 1, 2)}-${StringUtils.paddingZeroLeft(now.getDate(), 2)}`);
    // this.checkTime.set(`00:00:00`);
    this.checkTime.set(undefined);
  }

  rightSearch() {
    if (!this.personalId()) {
      return;
    }
    let effectiveDate;
    if (this.checkTime()) {
      effectiveDate = `${this.checkDate()}T${this.checkTime()}`;
    } else {
      effectiveDate = `${this.checkDate()}T00:00:00`;
    }
    this.rightSearchResource.search(this.personalId(), effectiveDate, this.source())
      .subscribe({
        next: value => {
          this.data.set(value);
        }
      });
  }

  afterRegister() {
    this.router.navigate(['/secure/right-search']);
  }

  onTabChange(activeId: any) {
    this.activeId.set(activeId);
  }

  protected register(registrantType: RegistrantType): void {
    if (!this.personalId()) {
      return;
    }
    this.rightSearchResource.registerSearch(this.personalId(), undefined, undefined)
      .subscribe({
        next: value => {
          this.data.set(value);
          this.registrantType = registrantType;
        }
      });
  }
}
